import { put, select } from 'redux-saga/effects';
import { screenshareStopped } from 'features/screenshare/actions';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import { ScreenshareSourceDetails } from 'features/layout/types';
import { UserId } from 'features/users/types';
import { RTCClient } from 'utils/webrtc';

export function* cleanupUserScreensharesSaga(userId: UserId) {
  const screenshares: ScreenshareSourceDetails[] = yield select(selectScreenshareStreams);

  for (const screenshare of screenshares) {
    if (screenshare.userId === userId && screenshare.feedId) {
      const streams = RTCClient.receivingFeed.media.getMediaList(screenshare.feedId);

      yield put(
        screenshareStopped({
          id: screenshare.userId,
          feedId: screenshare.feedId,
          streams,
        })
      );
    }
  }
}
